// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageGuard_root__jwfUX","red":"ImageGuard_red__5_w4x","showButton":"ImageGuard_showButton__Y8STQ"};